import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { backend } from '@shared/datastore/core';
import { contactsBackend } from './contacts.backend';
// import { DatastoreBackendModule } from '@shared/datastore/core';
import { contactsReducer } from './contacts.reducer';

// FIXME: remove that
backend.contacts = contactsBackend;

@NgModule({
  imports: [
    StoreModule.forFeature('contacts', contactsReducer),
    /* DatastoreBackendModule.forFeature(
      'contacts',
      contactsBackend,
    ),*/
  ],
})
export class DatastoreContactsModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/contacts/contacts.module.ts